module.exports = __webpack_public_path__ + "media/components/assets/img/logo/lufthansa-fd05dca86222f22cef7ff0f13c6529dd.png";